import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-32 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-5xl md:text-7xl font-bold text-white mb-10 tracking-tight">
              Let's talk about what you're building
            </h2>
            <Link
              to="/contact"
              className="inline-block bg-[#3b82f6] text-white px-12 py-5 rounded-2xl font-black text-xl hover:bg-[#2563eb] transition-all shadow-2xl shadow-[#3b82f6]/20 uppercase tracking-widest"
            >
              Get in touch
            </Link>
            
            <div className="mt-20 pt-20 border-t border-[#344271]">
              <p className="text-[#94a3b8] text-sm font-bold uppercase tracking-[0.2em] mb-4">Operator Opportunities</p>
              <p className="text-[#e2e8f0]/60 max-w-xl mx-auto italic font-medium">
                Interested in taking over or partnering on a Crucible Lab product? 
                Select "Partnership" in the contact form.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTA;